import { memo } from 'react'
import styled from 'styled-components'
import { colors } from '@/styles'

const Panel = styled.section`
  background: ${props => props.color || colors.white};
  border-radius: 16px;
  padding: ${props => props.vSpace}px ${props => props.hSpace}px;
  margin-top: ${props => (props.top ? `${props.top}px` : 0)};
  box-shadow:
    0px 2px 1px 0px rgba(0, 0, 0, 0.05),
    0px 0px 1px 0px rgba(0, 0, 0, 0.25);

  &[type='button'] {
    border: 0;
    cursor: pointer;
  }

  @media print {
    border: none;
    padding-top: 0;
    padding-bottom: 0;
  }
`

Panel.defaultProps = {
  hSpace: 20,
  vSpace: 20
}

export default memo(Panel)
